// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"57433bc7","31":"6e39b055","115":"6e39b055","195":"3288786a","335":"3b18d994","383":"af6f1e06","634":"be30dc20","729":"6cce50eb","734":"39efe904","812":"20781435"}[chunkId] + ".chunk.css";
};